import { Button, Layout, Typography } from 'antd';
import { FunctionComponent } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../App.css';

const { Header } = Layout;
const { Title } = Typography;

const headerStyle: React.CSSProperties = {
  backgroundColor: "#1a80b1",
  padding: "0 24px",
  minHeight: 80,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexWrap: "wrap",
  gap: "10px"
};

const titleStyle: React.CSSProperties = {
  color: "white",
  margin: 0,
  cursor: "pointer",
  fontSize: "clamp(18px, 2vw, 28px)", // responsive auto
};

const HeaderPeche: FunctionComponent = () => {
    const navigate = useNavigate();

    function goToAccueil() {
        navigate("/")
    }

    return (
        <Header style={headerStyle}>
            <title>Application pêche</title>

            <Title onClick={goToAccueil} style={titleStyle}>Réservation pêche de nuit - Oye-Plage</Title>

            <Button type='primary' style={{ backgroundColor: "#0050CC" }} onClick={() => { navigate("connexion") }}>Espace utilisateur</Button>
        </Header>
    );
}

export default HeaderPeche;
